import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const CartRecoveryModal = ({ recovery, onViewSales }) => {
  const { snapshot, busy, error, restore, discard } = recovery;
  const modalRef = useRef(null);
  useEffect(() => {
    if (!snapshot) return;
    const previous = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    modalRef.current?.focus();
    return () => {
      document.body.style.overflow = previousOverflow;
      previous?.focus?.();
    };
  }, [snapshot]);
  if (!snapshot) return null;
  const uncertain = snapshot.pendingSubmission || snapshot.externalChange;
  const trapFocus = (event) => {
    if (event.key !== "Tab") return;
    const buttons = [...modalRef.current.querySelectorAll("button:not(:disabled)")];
    if (!buttons.length) return event.preventDefault();
    const first = buttons[0];
    const last = buttons[buttons.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === modalRef.current)) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  };
  return createPortal(
    <div className="modal modal-blur show d-block pos-cart-recovery-modal" role="dialog" aria-modal="true"
      aria-labelledby="cart-recovery-title" tabIndex={-1} ref={modalRef} onKeyDown={trapFocus}
      style={{ background: "rgba(0, 0, 0, 0.3)", zIndex: 1090 }}>
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header"><h5 className="modal-title" id="cart-recovery-title">{uncertain ? "Cek transaksi dulu" : "Keranjang belum selesai"}</h5></div>
          <div className="modal-body">
            {uncertain ? <p className="mb-0">{snapshot.externalChange ? "Keranjang berubah di tab lain. Lanjutkan di tab tersebut." : "Transaksi sebelumnya mungkin sudah tersimpan. Cek halaman Penjualan agar tidak tercatat dua kali."}</p> : <>
              <p className="mb-2">Masih ada <strong>{snapshot.details.length} jenis produk</strong> di keranjang. Mau lanjutkan?</p>
              <div className="text-secondary small mb-3">Disimpan {new Date(snapshot.savedAt).toLocaleString("id-ID")}</div>
              <p className="mb-0 text-secondary">Harga dan stok akan dicek lagi. Isi ulang jumlah bayar sebelum membayar.</p>
            </>}
            {error ? <div className="alert alert-warning mt-3 mb-0" role="alert">{error}</div> : null}
          </div>
          <div className="modal-footer">
            {!snapshot.externalChange ? <button className="btn btn-ghost-danger" disabled={busy} onClick={discard}>Buang keranjang</button> : null}
            {uncertain ? <button className="btn btn-primary" onClick={onViewSales}>Lihat Penjualan</button>
              : <button className="btn btn-primary" disabled={busy} onClick={restore}>{busy ? "Mengecek..." : "Lanjutkan"}</button>}
          </div>
        </div>
      </div>
    </div>, document.body,
  );
};

export default CartRecoveryModal;
